
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/ethical-ai-learning-law",
      function () {
        return require("private-next-pages/articles/ethical-ai-learning-law.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/ethical-ai-learning-law"])
      });
    }
  